























import { Component, Prop, Mixins } from 'vue-property-decorator'

import AppTile from '@/components/AppTile.vue'

import { Common } from '@/mixins'

interface Feed {
  medias: {
    subMedias: {
      type: string;
      ownerUseType: string;
      path: string;
    }[];
  }[];
}

@Component({
  components: {
    AppTile
  }
})
export default class extends Mixins(Common) {
  @Prop() readonly feeds!: object[]
}
